import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { TranslateService } from '@ngx-translate/core';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { UrlParams } from '../../modules/url-params/model/url-params.model';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

/**
 * Effect used to load language based on url param. It is called in the initial app bootstrap and never again.
 */
@Injectable()
export class LanguageEffects {

    constructor(private store: Store<AppState>, private translate: TranslateService, private titleService: Title ) {

        // if the url is missing lang parameter on initial access (redirect from MCI or George) and user is redirected to 401
        // then the bundle is not loaded, page is not localised and only message keys are displayed, for example: APP.UNAUTHORIZED.TITLE
        // this causes the cs.json to be loaded and proper messages displayed
        translate.setDefaultLang('cs');

        /* should be emitted only once, when root url is visited and &lang=cs provided
        that's also why we don't need to unsubscribe */
        this.store.select(selectUrlParams).subscribe((params: UrlParams) => {
            if (!!params) {
                translate.use(params.lang);
                this.translate.get('APP.APP-TITLE').subscribe((title: string) => {
                    if (!!title) {
                        this.titleService.setTitle(title);
                    }
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/effects/language.effects.ts